import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';


import {AdminPermissions} from './admin-permissions';
import {AdminRoleSelect} from './admin-role-select';
import {ResetAdminPermissions} from './reset-admin-permissions';

import type {Dispatch, SetStateAction} from 'react';
import type {ProfileRecord} from 'src/openapi/admin/models/ProfileRecord';

type Props = {
    isLoading: boolean,
    disabled?: boolean,
    role: ProfileRecord | null,
    roles: ProfileRecord[] | null,
    isDefaultAdminPermissions: boolean,
    resetAdminPermissions: () => void,
    changeRole: (role: (ProfileRecord | null)) => void,
    adminPermissions: string[],
    defaultAdminPermissions: string[],
    setAdminPermissions: Dispatch<SetStateAction<string[]>>,
};
export const AdminRoleSettings = ({
    isLoading,
    disabled,
    role,
    roles,
    isDefaultAdminPermissions,
    resetAdminPermissions,
    changeRole,
    adminPermissions,
    defaultAdminPermissions,
    setAdminPermissions,
}: Props) => (
    <FormSection
        headline="Admin Role Settings"
        info={isLoading ? () => <SkeletonItem width={200} height={28}/> : undefined}>
        <Group gap="l" direction="v" alignItems="start">
            <ResetAdminPermissions {...{
                disabled,
                isLoading,
                role,
                isDefaultAdminPermissions,
                onReset: resetAdminPermissions,
            }}
            />
            <AdminRoleSelect {...{
                disabled,
                isLoading,
                roles,
                role,
                changeRole,
            }}
            />
            <AdminPermissions {...{
                disabled: !role || disabled,
                isLoading,
                adminPermissions,
                defaultAdminPermissions,
                setAdminPermissions,
            }}
            />
        </Group>
    </FormSection>
);
